import { SimpleStorageService } from './simple-storage.service';

export const SimpleStorageModule = angular
  .module('sfMobile.services.simple-storage', [])
  .service('simpleStorageService', SimpleStorageService).name;
